import "../assets/css/style.css";
import { HomeBanner } from "../components/home-banner";
import { Categories } from '../components/categories/Categories';
import { useFetch } from '../hooks/useFetch';
import { getImageUrl } from '../helpers/img-resolve';
import { useNavigate } from 'react-router-dom';

export const MainPage = () => {

  const { data, isLoading } = useFetch('categories');

  const navigate = useNavigate();

  const categoryList = (data?.payload ?? []).toSorted((a, b) => a.order - b.order)
    .map((category) => ({
      id: category.id,
      name: category.label,
      icon: getImageUrl('icons', category.icon),
      offers: category.offers,
      disabled: category.disabled,
      route: category.route,
    }));


  const handleSearch = (query) => {
    navigate({
      pathname: '/service',
      search: `?query=${encodeURIComponent(query)}`
    });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="main-body flex-grow pb-24"> {/* Increased padding to prevent content overlap with footer */}
        <div className="max-w-[1280px] px-2 mx-auto">
          <HomeBanner onSearch={handleSearch}  />
          <Categories categoryList={categoryList} isLoading={isLoading}/>
          {/*<div className="w-[90%] md:w-[70%] lg:w-[540px] h-auto min-h-[120px] mx-auto border border-gray-300 mt-4">*/}
          {/*  <HomeAdsContainer/>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};



